import { useAuth } from 'user-auth'
import { useGetCurrentWorkspaceGuests } from '~workspace/queries/useGetWorkspaceById'

export const useIsWorkspaceGuest = () => {
  const { user } = useAuth()
  const guests = useGetCurrentWorkspaceGuests()

  if (!user) return false
  return guests.some((guest) => guest.user.id === user.id)
}
